import { Text, Box, ChatMessage } from 'pcln-design-system';
import React from 'react';
import { StyledLoadingBox } from './StyledLoadingBubble';
import { TravelBotLogoImage } from './TravelBotLogoImage';
/**
 * DialogLoading
 * Three dots loading component
 * @public
 */
export var DialogLoading = function (props) {
    var MessageIcon = function Icon() {
        return (React.createElement(TravelBotLogoImage, null));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ChatMessage, { mb: 4, Icon: MessageIcon, variation: 'initial', message: React.createElement(Box, null,
                props.streamingText &&
                    props.streamingText.split('\n').map(function (c, ci) { return (React.createElement(Text, { fontSize: 2, key: "chat-content-".concat(ci) }, c)); }),
                React.createElement(StyledLoadingBox, { mt: 1, bg: 'background.light', width: '62px', height: '32px', align: 'center', justifyContent: 'space-between' },
                    React.createElement("span", { id: 'ellipses_1' }),
                    React.createElement("span", { id: 'ellipses_2' }),
                    React.createElement("span", { id: 'ellipses_3' }))) })));
};
//# sourceMappingURL=DialogLoading.js.map